<template>
    <div class="report-menu">
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.OVERALL)"
            :class="{ active: currentTab === ReportTabs.OVERALL }"
        >
            <p class="label">
                <i class="material-icons">trending_up</i>

                {{ $t("report.overall") }}
            </p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.CHAT_DISTRIBUTIONS)"
            :class="{ active: currentTab === ReportTabs.CHAT_DISTRIBUTIONS }"
        >
            <p class="label"><i class="material-icons">donut_small</i>{{ $t("report.chatDistributions") }}</p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.CONTACT_DISTRIBUTIONS)"
            :class="{ active: currentTab === ReportTabs.CONTACT_DISTRIBUTIONS }"
        >
            <p class="label"><i class="material-icons">donut_small</i>{{ $t("report.contactDistributions") }}</p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.AGENT_PERFORMANCE)"
            :class="{ active: currentTab === ReportTabs.AGENT_PERFORMANCE }"
        >
            <p class="label"><i class="material-icons">speed</i>{{ $t("report.agentPerformance") }}</p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.AGENT_ACTIVITIES)"
            :class="{ active: currentTab === ReportTabs.AGENT_ACTIVITIES }"
        >
            <p class="label"><i class="material-icons">wifi</i>{{ $t("report.dailyAgentActivity") }}</p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.AGENT_WORK_TIME)"
            :class="{ active: currentTab === ReportTabs.AGENT_WORK_TIME }"
        >
            <p class="label"><i class="material-icons">history_toggle_off</i>{{ $t("report.teamBreakAnalysis") }}</p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>

        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.CUSTOMER_SATISFACTION)"
            :class="{ active: currentTab === ReportTabs.CUSTOMER_SATISFACTION }"
        >
            <p class="label">
                <i class="material-icons">sentiment_very_satisfied</i>{{ $t("report.customerSatisfaction") }}
            </p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.WEBSITE_ANALYSIS)"
            :class="{ active: currentTab === ReportTabs.WEBSITE_ANALYSIS }"
        >
            <p class="label"><i class="material-icons">query_stats</i>{{ $t("report.websiteAnalysis") }}</p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.CHANNEL_BREAKDOWN)"
            :class="{ active: currentTab === ReportTabs.CHANNEL_BREAKDOWN }"
        >
            <p class="label"><i class="material-icons">hub</i>{{ $t("report.channelBreakdown") }}</p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.WHATSAPP_BUSINESS_API)"
            :class="{ active: currentTab === ReportTabs.WHATSAPP_BUSINESS_API }"
        >
            <p class="label">
                <WhatsappBusinessIcon style="width: 30px; height: 30px" color="#58ca64" />
                Whatsapp Business API
            </p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.Calendar)"
            :class="{ active: currentTab === ReportTabs.Calendar }"
        >
            <p class="label">
                <i class="material-icons">calendar_month</i>
                {{ $t("message.calendar") }}
            </p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.Mail)"
            :class="{ active: currentTab === ReportTabs.Mail }"
        >
            <p class="label">
                <i class="material-icons">event_available</i>
                {{ $t("message.mails") }}
            </p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.Ticket)"
            :class="{ active: currentTab === ReportTabs.Ticket }"
        >
            <p class="label">
                <i class="material-icons">confirmation_number</i>
                {{ $t("message.ticket") }}
            </p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover mb-5"
            @click="updateQueryParams('report', ReportTabs.TASK)"
            :class="{ active: currentTab === ReportTabs.TASK }"
        >
            <p class="label">
                <i class="md-icon">picture_in_picture_alt</i>
                {{ $t("task.workflow") }}
            </p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import SnakeSpinner from "./SnakeSpinner.vue";
import BarSpinner from "./BarSpinner.vue";
import ReportTabs from "./ReportTabs";
import WhatsappBusinessIcon from "../../Pages/Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import { mapState } from "vuex";

export default Vue.extend({
    name: "ReportMenu",
    computed: {
        ReportTabs() {
            return ReportTabs;
        },
        ...mapState({
            user: (state) => state.auth.user,
            adminUser: (state) => state.auth.adminUser,
        }),
    },
    components: { WhatsappBusinessIcon, SnakeSpinner, BarSpinner },
    props: {
        stats: {
            type: Object,
            default: () => ({
                totalChatCount: 0,
                avgRate: 0,
                workInfo: {
                    totalWorkTime: 0,
                },
                breakInfo: {
                    totalBreakCount: 0,
                    totalBreakTime: 0,
                },
                totalWhatsappChatCount: 0,
                totalChatbotConversation: 0,
                missedChat: 0,
                destroyedCount: 0,
                avgChatDuration: 0,
                minChatDuration: 0,
                maxChatDuration: 0,
                avgFirstMessageTime: 0,
            }),
        },
        loading: {
            type: Boolean,
            default: true,
        },
        updateQueryParams: {
            type: Function,
            default: () => {},
        },
        currentTab: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            loadingBars: null,
        };
    },
    mounted() {
        console.log("mounted user", this.user);
        console.log("mounted adminUser", this.adminUser);
        this.loadingBars = Array.from(document.querySelectorAll(".box > .value")).map((el) => {
            return this.$veLoading({
                target: document.querySelector(".box > .value"),
                name: "wave",
            });
        });
        if (this.loading) {
            // this.loadingBars.forEach((bar) => bar.show());
        }
    },
    watch: {
        loading(newVal) {
            if (newVal) {
                // this.loadingBars.forEach((bar) => bar.show());
            } else {
                // this.loadingBars.forEach((bar) => bar.close());
            }
        },
    },
});
</script>

<style scoped lang="scss">
$box-colors: [ "#800080", "#FF8C00", "#8B4513", "#663399", "#FF0000", "#00FF00", "#0000FF", "#4B0082", "#8B0000",
    "#FFC0CB", "#008080", "#FFA500" ];

.report-menu {
    position: sticky;
    top: 0;
    overflow-y: auto;
    height: 100%;

    .box.no-shadow {
        box-shadow: none;
        cursor: auto;

        &:hover {
            box-shadow: none;
        }
    }

    .box.yes-hover {
        cursor: pointer;

        &:hover {
            background-color: #fff4de;
        }
    }

    .box {
        width: 300px;
        max-width: 300px;
        height: 36px;
        border-radius: 6px;
        display: flex;
        background-color: #ffffff;
        padding: 8px;
        align-items: center;
        margin: 5px;
        /* box-shadow: 0 0 3px #1E1E2D;*/
        cursor: pointer;
        transition: all 0.3s;

        .label {
            display: flex;
            gap: 5px;
            align-items: center;
            font-size: 14px;
            font-weight: 600;
            color: #181c32;
        }

        &.active {
            background-color: #fff4de;
            box-shadow: 0 0 6px #00000080;
        }

        .value {
            svg {
                width: 30px;
                height: 30px;
            }
        }

        &:hover {
            box-shadow: 0 0 6px #00000080;
        }

        &:last-child {
            margin-bottom: 0;
        }

        p {
            margin: 0;
            font-size: 12px;
            font-weight: 300;
            font-family: Poppins;
            color: #181c32;
            white-space: nowrap;
        }

        p + p {
            font-weight: 700;
            margin-left: auto;
        }
    }

    //&::before {
    //    content: "";
    //    display: block;
    //    min-width: 20px;
    //    height: 20px;
    //    border-radius: 3px;
    //    margin-right: 8px;
    //}

    @for $i from 0 through 10 {
        .box:nth-child(#{$i}) {
            .material-icons {
                color: unquote(nth($box-colors, $i + 1));
            }
        }
    }
}
</style>
